import { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('ro');
  const toggle = () => setLang(l => (l === 'ro' ? 'en' : 'ro'));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

export const useT = () => {
  const { lang } = useLang();
  return (obj) => (obj && obj[lang]) ? obj[lang] : (obj && obj['ro']) ? obj['ro'] : '';
};
